import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.p`
  font: ${props => props.theme.fontWeightRegular} 19px/130% ${props => props.theme.fontFamilyBody};
  margin: 0;
  margin-top: 24px;
  ${props => props.theme.isFeaturedMedium && `
    max-width: 712px;
  `};
  ${props => props.theme.isFeaturedLarge && `
    max-width: 780px;
  `};
  ${props => props.theme.isXXLarge && `
    max-width: 792px;
  `};
  color: ${props => props.theme.bodyColor};
`;
export default function Objective({ value }) {
  return <Text>{value}</Text>;
}

Objective.propTypes = { value: PropTypes.string.isRequired };
